
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M20.531 0H2.54C1.14 0 0 1.139 0 2.54v8.175a.508.508 0 101.016 0V2.539c0-.84.683-1.523 1.523-1.523h11.273V6.27a.508.508 0 00.867.36l1.266-1.266 1.266 1.266a.508.508 0 00.867-.36V1.016h.305c.84 0 1.523.683 1.523 1.523v20.922c0 .84-.683 1.523-1.523 1.523H2.539c-.84 0-1.523-.683-1.523-1.523v-8.176a.508.508 0 10-1.016 0v8.176A2.543 2.543 0 002.54 26h17.99a3.441 3.441 0 003.438-3.438V3.439A3.441 3.441 0 0020.53 0zm-3.469 5.046l-.758-.759a.506.506 0 00-.718 0l-.758.759v-4.03h2.234v4.03zm5.891 17.517a2.425 2.425 0 01-2.422 2.421h-.118a2.52 2.52 0 00.509-1.523V2.539a2.52 2.52 0 00-.51-1.523h.12a2.425 2.425 0 012.421 2.422v19.125z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M10.74 7.933L9.542 5.86a1.667 1.667 0 00-2.275-.61l-.42.243a5.138 5.138 0 00-1.878 7.011l3.407 5.902a5.099 5.099 0 003.116 2.391 5.102 5.102 0 003.895-.513l.42-.242a1.662 1.662 0 00.609-2.275l-1.184-2.05a1.654 1.654 0 00-1.01-.776 1.654 1.654 0 00-1.264.166l-1.277.737-2.829-4.9 1.277-.737a1.667 1.667 0 00.61-2.274zm2.727 8.054a.645.645 0 01.887.238l1.184 2.05a.645.645 0 01-.238.887s-.676.381-.807.44l-1.822-3.156.796-.46zm-2.587.5a.86.86 0 00.883.418l1.73 2.997a4.103 4.103 0 01-1.737-.086 4.09 4.09 0 01-2.5-1.918L5.85 11.996a4.123 4.123 0 01.384-4.67l1.742 3.018a.86.86 0 00-.08.973l2.985 5.17zm-1.258-7.16l-.796.46L6.992 6.61c.116-.085.784-.48.784-.48a.65.65 0 01.887.238L9.86 8.44a.65.65 0 01-.238.887zM.508 13.508A.512.512 0 001.016 13a.512.512 0 00-.508-.508A.512.512 0 000 13a.512.512 0 00.508.508z"}})])
          )
        }
      }
    